import styled from "styled-components";

export const StyledCol = styled.div`
  transition: border 150ms ease;

  &:not(first-child) {
    padding: 0 2.5px;
  }

  // ${(p) =>
    p.inlineStyle.alignItems && `align-items: ${p.inlineStyle.alignItems}`};
  // ${(p) =>
    p.inlineStyle.justifyContent &&
    `justify-content: ${p.inlineStyle.justifyContent}`};

  display: flex;
  flex-direction: column;

  // outline:1px solid #ccc;
  box-shadow: 0 0 0 1px #ccc;
`;

export const FakeCol = styled.div`
  margin-top: ${(p) =>
    p.inlineStyle && p.inlineStyle.marginTop
      ? p.inlineStyle.marginTop + p.inlineStyle.marginUnit
      : "0px"};
  margin-bottom: ${(p) =>
    p.inlineStyle && p.inlineStyle.marginBottom
      ? p.inlineStyle.marginBottom + p.inlineStyle.marginUnit
      : "0px"};
  padding-top: ${(p) =>
    p.inlineStyle && p.inlineStyle.paddingTop
      ? p.inlineStyle.paddingTop + p.inlineStyle.paddingUnit
      : "5px"};
  padding-bottom: ${(p) =>
    p.inlineStyle && p.inlineStyle.paddingBottom
      ? p.inlineStyle.paddingBottom + p.inlineStyle.paddingUnit
      : "5px"};
  padding-right: ${(p) =>
    p.inlineStyle && p.inlineStyle.paddingRight
      ? p.inlineStyle.paddingRight + p.inlineStyle.paddingUnit
      : "5px"};
  padding-left: ${(p) =>
    p.inlineStyle && p.inlineStyle.paddingLeft
      ? p.inlineStyle.paddingLeft + p.inlineStyle.paddingUnit
      : "5px"};

  display: flex;
  flex-direction: ${(p) =>
    p.inlineStyle.flexDirection ? p.inlineStyle.flexDirection : "column"};
  ${(p) =>
    p.inlineStyle.alignItems && `align-items: ${p.inlineStyle.alignItems}`};
  ${(p) =>
    p.inlineStyle.justifyContent &&
    `justify-content: ${p.inlineStyle.justifyContent}`};

  ${(p) => p.hoverConfig && `outline: 1px solid red`};

  //background-color: transparent;
  height: 100%;
  width: 100%;

  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 3px,
    #f1f1f1 3px,
    #f1f1f1 6px
  );

  // border-radius: 5px;
`;

export const Stacked = styled.span`
  font-size: 1.5em;
  color: #e68797;
`;

export const StyledEmptyColumnPlaceholder = styled.div`
  position: relative;
  color: #e68797;
  min-height: 160px;
  height: 100%;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 3px,
    #f1f1f1 3px,
    #f1f1f1 6px
  );
  border-radius: 5px;

  display: flex;
  align-items: center;

  // & > div {
  //     position: absolute;
  //     bottom: 0;
  //     right: 0;
  // }

  margin-top: ${(p) =>
    p.theme.standardComponent && p.theme.standardComponent.marginTop
      ? p.theme.standardComponent.marginTop
      : "0px"};
  margin-bottom: ${(p) =>
    p.theme.standardComponent && p.theme.standardComponent.marginBottom
      ? p.theme.standardComponent.marginBottom
      : "0px"};
  padding-top: ${(p) =>
    p.theme.standardComponent && p.theme.standardComponent.paddingTop
      ? p.theme.standardComponent.paddingTop
      : "5px"};
  padding-bottom: ${(p) =>
    p.theme.standardComponent && p.theme.standardComponent.paddingBottom
      ? p.theme.standardComponent.paddingBottom
      : "5px"};
  padding-right: ${(p) =>
    p.theme.standardComponent && p.theme.standardComponent.paddingRight
      ? p.theme.standardComponent.paddingRight
      : "5px"};
  padding-left: ${(p) =>
    p.theme.standardComponent && p.theme.standardComponent.paddingLeft
      ? p.theme.standardComponent.paddingLeft
      : "5px"};
`;

export const IconsWrapper = styled.div`
  position: absolute;
  bottom: -40px;
  right: 10px;
  transition: opacity 150ms ease;
  opacity: ${(p) => (p.hover ? 1 : 0)};
  padding-top: 20px;
  z-index: 50; // ensure that add component model is over this button
`;

export const Icons = styled.div`
  display: flex;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  padding: 0px 0px 0px 10px;
  cursor: pointer;
  // margin-top:20px;
`;

export const ConfigIcon = styled.button`
  background-color: #fff;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 10px;
  font-size: 18px;
  color: #777;
  //	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  // border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }

  &:hover {
    color: #222;
  }
`;

export const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
